import { Button, SearchableSelect } from 'components/core';
import { FILTER_OPS } from 'helpers/kpiBuilder/custom';
import { CustomFilter, FieldDef } from 'helpers/kpiBuilder/types';
import { FieldPicker } from './FieldPicker';
import { TextBox } from './TextBox';
import { OUTLINE_SMALL } from './buttonProps';

interface FilterRowProps {
  filter: CustomFilter;
  fields: FieldDef[];
  onChange: (filter: CustomFilter) => void;
  onRemove?: () => void;
}

const labelOf = (id: string): string => FILTER_OPS.find((o) => o.id === id)?.label ?? '';

// One condition: a field, how to compare it, and the value(s).
export const FilterRow = ({ filter, fields, onChange, onRemove }: FilterRowProps) => {
  const values = FILTER_OPS.find((o) => o.id === filter.op)?.values ?? 1;
  const remove = () => {
    onRemove?.();
  };

  return (
    <div className="border rounded p-2 mb-2 bg-white">
      <FieldPicker fields={fields} value={filter.field} placeholder="Field name, e.g. channel" onChange={(field) => onChange({ ...filter, field })} />
      <div className="row g-2 mt-1">
        <div className="col-md-4">
          <SearchableSelect options={FILTER_OPS.map((o) => o.label)} selected={labelOf(filter.op)} onChange={(t) => onChange({ ...filter, op: FILTER_OPS.find((o) => o.label === t)?.id ?? filter.op })} />
        </div>
        {values >= 1 && (
          <div className="col-md-4">
            <TextBox value={filter.value} placeholder={values === 2 ? 'From' : 'Value'} onChange={(value) => onChange({ ...filter, value })} />
          </div>
        )}
        {values === 2 && (
          <div className="col-md-4">
            <TextBox value={filter.value2} placeholder="To" onChange={(value2) => onChange({ ...filter, value2 })} />
          </div>
        )}
      </div>
      {onRemove && (
        <div className="mt-2">
          <Button {...OUTLINE_SMALL} onClick={remove}>
            Remove condition
          </Button>
        </div>
      )}
    </div>
  );
};
